export default __webpack_public_path__ + "static/media/Spin torre RI_Interactive LightMix0015.9aa4c5fd.webp";